import CounterfeitPanel from "./counterfeitPanel.container";

export default CounterfeitPanel;